/**
 * Sticky mobile CTA — PDP redesign (Varijanta B)
 * Vidi design_handoff_stickershop_pdp/IMPLEMENTATION-CHECKLIST.md #8.
 *
 * NE duplira product-form: dugme klikće postojeći submit button unutar
 * forme čiji id je prosleđen kroz data-form-id, tako da native GA4
 * add_to_cart event (ADR-001) ostaje netaknut.
 *
 * Floating widgeti: dok je traka vidljiva, <body> dobija klasu
 * `pdp-sticky-cta-active` — CSS u pdp-redesign.css pomera Chatty/Google
 * badge selektore za +72px. Ti selektori su best-effort (app injektuje
 * svoj markup) — proveriti u devtools i po potrebi dopuniti listu u
 * OTHER_WIDGET_SELECTORS ispod.
 */
(function () {
  var MOBILE_BREAKPOINT = 750;
  var WIDGET_OFFSET_CLASS = 'pdp-sticky-cta-active';

  function initStickyCta(bar) {
    var formId = bar.getAttribute('data-form-id');
    var observeTargetId = bar.getAttribute('data-observe-target');
    var form = formId ? document.getElementById(formId) : null;
    var observeTarget = observeTargetId ? document.getElementById(observeTargetId) : null;
    var button = bar.querySelector('[data-pdp-sticky-cta-button]');
    var priceEl = bar.querySelector('.pdp-sticky-cta__price');

    if (!form || !observeTarget || !button) {
      return;
    }

    // --- Klik: submituj postojeću formu, ne kreiraj novu ---
    button.addEventListener('click', function () {
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.click();
      } else if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });

    // --- Prati da li je originalni buy-buttons blok u viewportu ---
    function isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function setVisible(visible) {
      var shouldShow = visible && isMobile();
      bar.classList.toggle('pdp-sticky-cta--visible', shouldShow);
      document.body.classList.toggle(WIDGET_OFFSET_CLASS, shouldShow);
    }

    // Kad je observe div raspakovan kroz display:contents (pdp-qty-cta-row),
    // nema sopstveni box i IntersectionObserver bi uvek javljao "van
    // viewporta" — u tom slučaju posmatraj submit dugme forme.
    var targetBox = observeTarget.getBoundingClientRect();
    var observedEl = observeTarget;
    if (!targetBox.width && !targetBox.height) {
      observedEl = form.querySelector('[type="submit"]') || observeTarget;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(observedEl);

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        bar.classList.remove('pdp-sticky-cta--visible');
        document.body.classList.remove(WIDGET_OFFSET_CLASS);
      }
    });

    // --- Prati promenu cene (npr. promena varijante) i ogledaj je u traci ---
    if (priceEl) {
      var sectionId = observeTargetId.replace('pdp-buy-buttons-observe-', '');
      var priceSource = document.getElementById('price-' + sectionId);
      if (priceSource) {
        var syncPrice = function () {
          var priceItem = priceSource.querySelector('.price-item--regular, .price-item--last, .price-item')
            || priceSource;
          var text = priceItem.textContent.trim().split(/\s{2,}/)[0].trim();
          if (text) {
            priceEl.textContent = text;
          }
        };
        syncPrice();
        new MutationObserver(syncPrice).observe(priceSource, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pdp-sticky-cta]').forEach(initStickyCta);
  });
})();
